import { render } from "./SliderDetail.vue?vue&type=template&id=6915c874&scoped=true"
import script from "./SliderDetail.vue?vue&type=script&lang=js"
export * from "./SliderDetail.vue?vue&type=script&lang=js"

import "./SliderDetail.vue?vue&type=style&index=0&id=6915c874&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6915c874"]])

export default __exports__